import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { errorToast } from "@/v2-ui/toast"
import type { IconNames } from "@/v2-ui/icon/icon.types"
import Icon from "@/v2-ui/icon"
import DropdownMenu from "@/v2-ui/dropdownMenu"

export type ActionMenuItemVariant = "destructive" | "success" | "warning"

export type ActionMenuItemProps = ComponentProps<typeof DropdownMenu.Item> & {
  iconSrc?: IconNames
  iconSize?: number
  variant?: ActionMenuItemVariant
  isLoading?: boolean
  error?: Error | null | undefined
  errorTitle?: string
}

function ActionMenuItem(props: ActionMenuItemProps) {
  const {
    iconSrc,
    iconSize = 14,
    variant,
    isLoading,
    error,
    errorTitle,
    disabled,
    className,
    children,
    ...rest
  } = props

  errorToast(error ?? null, { title: errorTitle })

  return (
    <DropdownMenu.Item
      disabled={disabled || isLoading}
      className={cn(
        "action-menu-item",
        variant && `action-menu-item-${variant}`,
        className,
      )}
      {...rest}
    >
      {isLoading ? (
        <Icon loading size={iconSize} />
      ) : (
        iconSrc && <Icon src={iconSrc} size={iconSize} />
      )}
      {children}
    </DropdownMenu.Item>
  )
}

export default ActionMenuItem
